<template>
  <action-notification
    :add="toAdd"
    :remove="toRemove"
    @undo="revertAction"
  />
</template>

<script>
import ActionNotification from '@/components/ActionNotification';
import { mapGetters, mapActions } from 'vuex';
import MailParams from '@/settings/mail.js';

export default {
  name: 'mail-action',
  data() {
    return {
      toAdd: null,
      toRemove: null
    };
  },
  components: {
    'action-notification': ActionNotification
  },
  computed: {
    ...mapGetters({
      mail: 'mail/actionMail'
    })
  },
  methods: {
    ...mapActions({
      mailAction: 'mail/mailAction',
      groupMailAction: 'mail/groupMailAction',
    }),
    isUndo(val) {
      let curItem = this.items.find(item => item.id == val.id);

      return curItem && curItem.action == val.action && curItem.enabled == !val.enabled;
    },
    revertAction(val) {
      if (val.item) {
        this.mailAction({
          id: val.id,
          action: val.action,
          enabled: !val.enabled,
          undo: true
        });
      } else if (val.items) {
        this.groupMailAction({
          action: val.action,
          toSend: {
            enabled: !val.enabled,
            ids: val.items.map(item => item.id),
            undo: true
          }
        });
      }
    }
  },
  watch: {
    mail(val) {
      if (!val.undo) {
        let text = '';
        let undo = true;

        if (val.enabled)
          text = `${MailParams.actions[val.action].data.pending.text}`;
        else
          text = `Cancel ${MailParams.actions[val.action].btn.text}`;

        if (val.item) {
          text += ` for mail #${val.item.mail_number}`;
        } else if (val.items) {
          text += ` for ${val.items.length} mail item${val.items.length > 1 ? 's' : ''}`;
        }

        this.toAdd = {
          id: val.id,
          ...val,
          text,
          undo,
        }
      } else {
        this.toRemove = val.id;
      }
    }
  }
}
</script>
